import {
  Button,
  Container,
  FormControl,
  Grid,
  Input,
  InputAdornment,
  InputLabel,
  TextField,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import peplogo from "../../assets/Login_Header.svg";
import ssoIcon from "../../assets/ssoIcon.png";
import styles from "./LoginComponent.module.css";
import { useEffect, useState } from "react";
import spndWiseLogo from "../../assets/spendwise_logo.svg";
import mailIcon from "../../assets/mail-01.svg";
import loginIcon from "../../assets/login.svg";

import { useOktaAuth } from "@okta/okta-react";

const LoginComponent = () => {
  const { oktaAuth } = useOktaAuth();

  const [email, setEmail] = useState("");

  const navigate = useNavigate();

  useEffect(() => {
    if (oktaAuth) {
      oktaAuth.tokenManager.on("added", () => {
        navigate("/");
      });
    }
  });

  useEffect(() => {
    const checkAuthentication = async () => {
      const isAuthenticated = await oktaAuth.isAuthenticated();
      if (isAuthenticated) {
        navigate("/home");
      }
    };

    checkAuthentication();
  }, [oktaAuth, navigate]);

  const handleSSOSignIn = async() => {
    await oktaAuth.signInWithRedirect({ loginHint: email, originalUri: "/home" });
  };

  return (
    <form
      onSubmit={(event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        handleSSOSignIn();
      }}
      style={{
        background: `url('${process.env.PUBLIC_URL}/img/icons/pepsi.jpg')`,
        height: "100vh",
      }}
    >
      <Grid container className={styles.mainDiv} direction="row-reverse" >
        <Grid item xs={12} sm={6} md={6} lg={6}>
        <img src={spndWiseLogo} className={styles.spndWiseLogo}/>
          <Container className={styles.loginContainer} maxWidth="xs">
            <img src={peplogo} alt="peplogo" style={{marginLeft: '55px', marginBottom: '30px'}}/>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={12}>
                  <InputLabel htmlFor="userEmail" style={{marginBottom: '8px'}}>Email</InputLabel>
                  <TextField
                    id="userEmail"
                    name="userEmail"
                    type="email"
                    value={email}
                    onChange={(e) => {
                      setEmail(e.target.value);
                    }}
                    required
                    size="small"
                    fullWidth
                    InputProps={{
                    startAdornment:(
                      <InputAdornment position="start">
                        <img src={mailIcon} alt="mailIcon"/>
                      </InputAdornment>
                    )
                  }}
                  placeholder="name@company.com"
                  />
              </Grid>
              <Grid item xs={12} sm={12} textAlign="center">
                <Button
                  type="submit"
                  variant="contained"
                  className={styles.submitBtn}
                  style={{marginTop: '1rem', borderRadius: '10px'}}
                >
                  <img src={loginIcon} alt="loginIcon"/>
                  Login with SSO
                </Button>
              </Grid>
            </Grid>
          </Container>
        </Grid>
        <Grid style={{background: "linear-gradient(#013771,#306BB7);" }}
          item
          xs={5}
          sm={5}
          md={5}
          lg={6}
          className={styles.backgroundImage}
          sx={{display: {xs: 'none', sm: 'block'}}}
        >
          {/* <div className={styles.backgroundImage}></div> */}
        </Grid>
      </Grid>
    </form>
  );
};

export default LoginComponent;
